export default __webpack_public_path__ + "static/media/9410-niftynaut.87c1ea33.pdf";